import note from './note';
const ajaxurl = recoverit.ajaxurl;
const ajaxnonce = recoverit.ajaxnonce;

const request = async (data) => {
    try {
        const response = await fetch(ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-WP-Nonce': ajaxnonce,
            },
            body: new URLSearchParams(data).toString()
        });

        if (!response.ok) {
            throw new Error(`Request failed with status ${response.status}`);
        }

        const result = await response.json();
        process(data.method, result);

    } catch (error) {
        note('It seems there was an error with your request. Please try again later or contact support for assistance.');
    }
};

// Process server response
const process = (method, response) => {
    const container = document.querySelector('.rit-ajax');
    const loader = document.querySelector('.rit-loader');

    if (!container) {
        console.error('Ajax container not found. Ensure the element with class "rit-ajax" exists in the DOM.');
        return;
    }
    
    const handlers = {
        filter: () => {
            if (response.posts) {
                container.innerHTML = response.posts;

                const pagination = document.querySelector('.rit-pagination__list');
                if (pagination) {
                    pagination.innerHTML = response.pagination;
                }
            }
        },
        default: () => {
            container.innerHTML = response.message || 'No specific handler found for this method.';
        }
    };

    if (loader) loader.remove();

    // Call the relevant handler or default if not found
    (handlers[method] || handlers.default)();

    // Display a note if provided in the response, otherwise a default message
    // note(response.note || 'Action completed successfully.');
    // note(response.note || '');
};

export default request;